import {instance} from '@/api';
import {raceApi} from '@/api';
import moment from 'moment-timezone';
import {snakeCase} from "@/mixins/static-helpers";


function compareByR(a, b) {

	let aR = parseInt(a.code.replace('R', ''));
	let bR = parseInt(b.code.replace('R', ''));

	return aR - bR;
}


/*
* @description Filter DISABLED races from meetings.
* @param {array} meetings List of meetings with races
* @return {array} List of meetings without DISABLED races
*
* */
function filterDisabled(meetings) {

	meetings.forEach(meeting => {
		meeting.races = meeting.races.filter(race => race.status !== 'DISABLED');
	});

	return meetings.filter(meeting => meeting.races.length !== 0);
}

export default {
	state: {
		selected: null,
		timeline: {
			today: null,
			specified: null
		},

		current: {
			meeting: null,
			race: null
		},

		meetingId: null,
		raceId: null,
		rules: [
			{
				name: "Simple Gagnant",
				param: {
					minstake: 150,
					horses: 1,
					complimentary: false,
					hasjackpot: false
					//Other options in default computed property "rule"
				},
				priority: 101
			},
			{
				name: "E Simple Gagnant",
				param: {
					minstake: 150,
					horses: 1,
					complimentary: false,
					hasjackpot: false
					//Other options in default computed property "rule"
				},
				priority: 801
			},
			{
				name: "Simple Gagnant Jackpot",
				param: {
					minstake: 200,
					horses: 1,
					maxHorses: 1,
					complimentary: false,
					hasjackpot: true,
					jackpot_coefficient: 0.6666
					//Other options in default computed property "rule"
				},
				priority: 105
			},
			{
				name: "Simple Place",
				param: {
					minstake: 150,
					horses: 1,
					complimentary: false,
					hasjackpot: false
				},
				priority: 102
			},
			{
				name: "E Simple Place",
				param: {
					minstake: 150,
					horses: 1,
					complimentary: false,
					hasjackpot: false
				},
				priority: 802
			},
			{
				name: "Simple Place Jackpot",
				param: {
					minstake: 200,
					horses: 1,
					maxHorses: 1,
					complimentary: false,
					hasjackpot: true,
					jackpot_coefficient: 0.6666
				},
				priority: 106
			},

			{
				name: "Simple Gagnant International",
				param: {
					minstake: 150,
					horses: 1
				},
				priority: 103
			},
			{
				name: "Simple Place International",
				param: {
					minstake: 150,
					horses: 1
				},
				priority: 104
			},
			{
				name: "Gagnant Place",
				param: {
					minstake: 600,
					horses: 1,
					complimentary: false,
					hasboxed: false,
					hasx: false,
					hasall: false,
					hasrepl: false,
					hasspot: false,
					flexi50: false,
					flexi25: false,
					flexi10: false
				},
				priority: 201
			},
			{
				name: "Deux Sur Quatre",
				param: {
					minstake: 300,
					horses: 2,
					complimentary: true,
					hasboxed: false,
					hasx: true,
					hasall: true,
					hasrepl: true,
					hasspot: true,
					flexi50: true,
					flexi25: true,
					flexi10: false,
					spotCombinedOptions: [ 3, 4, 5, 6, 7, 8],
					spotInsert: false,
					hasjackpot: false
				},
				priority: 301
			},
			{
				name: "Deux Sur Quatre Jackpot",
				param: {
					minstake: 400,
					horses: 2,
					maxHorses: 2,
					complimentary: false,
					hasboxed: false,
					hasx: false,
					hasall: false,
					hasrepl: true,
					hasspot: false,
					flexi50: true,
					flexi25: true,
					flexi10: false,
					spotCombinedOptions: [ 3, 4, 5, 6, 7, 8],
					spotInsert: false,
					hasjackpot: true,
					jackpot_coefficient: 0.75
				},
				priority: 302
			},
			{
				name: "Couple Gagnant",
				param: {
					minstake: 150,
					horses: 2,
					complimentary: true,
					hasx: true,
					hasall: true,
					hasspot: true,
					flexi50: true,
					spotCombinedOptions: [ 3, 4, 5, 6, 7, 8]
				},
				priority: 201
			},
			{
				name: "E Couple Gagnant",
				param: {
					minstake: 150,
					horses: 2,
					complimentary: true,
					hasx: true,
					hasall: true,
					hasspot: true,
					flexi50: true,
					spotCombinedOptions: [ 3, 4, 5, 6, 7, 8]
				},
				priority: 901
			},
			{
				name: "Couple Place",
				param: {
					minstake: 150,
					horses: 2,
					complimentary: true,
					hasx: true,
					hasall: true,
					hasspot: true,
					flexi50: true,
					spotCombinedOptions: [ 3, 4, 5, 6, 7, 8]
				},
				priority: 202
			},
			{
				name: "E Couple Place",
				param: {
					minstake: 150,
					horses: 2,
					complimentary: true,
					hasx: true,
					hasall: true,
					hasspot: true,
					flexi50: true,
					spotCombinedOptions: [ 3, 4, 5, 6, 7, 8]
				},
				priority: 902
			},
			{
				name: "Couple Ordre",
				param: {
					minstake: 150,
					horses: 2,
					complimentary: true,
					hasboxed: true,
					hasx: true,
					hasall: true,
					hasspot: true,
					flexi50: true,
					spotCombinedOptions: [ 3, 4, 5, 6, 7, 8],
					spotInsert: true
				},
				priority: 203
			},
			{
				name: "E Couple Ordre",
				param: {
					minstake: 150,
					horses: 2,
					complimentary: true,
					hasboxed: true,
					hasx: true,
					hasall: true,
					hasspot: true,
					flexi50: true,
					spotCombinedOptions: [ 3, 4, 5, 6, 7, 8],
					spotInsert: true
				},
				priority: 903
			},
			{
				name: "Couple Ordre International",
				param: {
					minstake: 150,
					horses: 2,
					complimentary: false,
					hasboxed: true,
					hasx: true,
					hasall: true,
					hasspot: false,
				},
				priority: 204
			},
			{
				name: "Tierce",
				param: {
					minstake: 100,
					horses: 3,
					complimentary: true,
					hasboxed: true,
					hasx: true,
					hasall: true,
					hasrepl: true,
					hasspot: true,
					flexi50: true,
					flexi25: false,
					flexi10: false,
					spotCombinedOptions: [ 4, 5, 6, 7, 8],
					spotInsert: true
				},
				priority: 501
			},
			{
				name: "Classic Tierce",
				param: {
					minstake: 100,
					horses: 3,
					complimentary: false,
					hasboxed: true,
					hasx: true,
					hasall: true,
					hasrepl: true,
					hasspot: true,
					flexi50: true,
					flexi25: false,
					flexi10: false
				},
				priority: 307
			},
			{
				name: "Trio",
				param: {
					minstake: 150,
					horses: 3,
					complimentary: true,
					hasboxed: false,
					hasx: true,
					hasall: true,
					hasrepl: true,
					hasspot: true,
					flexi50: true,
					spotCombinedOptions: [4, 5, 6, 7, 8]
				},
				priority: 401
			},
			{
				name: "E Trio",
				param: {
					minstake: 150,
					horses: 3,
					complimentary: true,
					hasboxed: false,
					hasx: true,
					hasall: true,
					hasrepl: true,
					hasspot: true,
					flexi50: true,
					spotCombinedOptions: [4, 5, 6, 7, 8]
				},
				priority: 1001
			},
			{
				name: "Trio Ordre",
				param: {
					minstake: 150,
					horses: 3,
					associate: true,
					complimentary: true,
					hasboxed: true,
					hasx: true,
					hasall: true,
					hasrepl: false,
					hasspot: true,
					flexi50: true,
					spotCombinedOptions: [ 4, 5, 6, 7, 8],
					spotInsert: true
				},
				priority: 402
			},
			{
				name: "E Trio Ordre",
				param: {
					minstake: 150,
					horses: 3,
					associate: true,
					complimentary: true,
					hasboxed: true,
					hasx: true,
					hasall: true,
					hasrepl: false,
					hasspot: true,
					flexi50: true,
					spotCombinedOptions: [ 4, 5, 6, 7, 8],
					spotInsert: true
				},
				priority: 1002
			},
			{
				name: "Trio Ordre International",
				param: {
					minstake: 150,
					horses: 3,
					complimentary: false,
					hasboxed: true,
					hasx: true,
					hasall: true,
					hasrepl: false,
					hasspot: false
				},
				priority: 403
			},
			{
				name: "Multi",
				param: {
					minstake: 300,
					horses: 4,
					multiOptions: [
						4,
						5,
						6,
						7
					],
					hasboxed: false,
					hasx: true,
					hasall: false,
					hasrepl: false,
					hasspot: true,
					flexi50: true,
					flexi25: true,
					flexi10: false,
					spotCombinedOptions: [ 5, 6, 7, 8]
				},
				priority: 702
			},
			{
				name: "Quarte+",
				param: {
					minstake: 130,
					horses: 4,
					complimentary: true,
					hasboxed: true,
					hasx: true,
					hasall: true,
					hasrepl: true,
					hasspot: true,
					flexi50: true,
					spotCombinedOptions: [ 5, 6, 7, 8],
					spotInsert: true
				},
				priority: 601
			},
			{
				name: "Quarte",
				param: {
					minstake: 130,
					horses: 4,
					complimentary: true,
					hasboxed: true,
					hasx: true,
					hasall: true,
					hasrepl: true,
					hasspot: true,
					flexi50: true,
					spotCombinedOptions: [ 5, 6, 7, 8],
					spotInsert: true
				},
				priority: 600
			},
			{
				name: "Quinte+",
				param: {
					minstake: 200,
					horses: 5,
					complimentary: true,
					hasboxed: true,
					hasx: true,
					hasall: true,
					hasrepl: true,
					hasspot: true,
					spotCombinedOptions: [6, 7, 8],
					spotInsert: true,
					flexi50: true,
					flexi25: true
				},
				priority: 603
			},
			{
				name: "Super4",
				param: {
					minstake: 100,
					horses: 4,
					complimentary: true,
					hasboxed: true,
					hasx: true,
					hasall: true,
					hasrepl: true,
					hasspot: true,
					flexi50: true,
					flexi25: false,
					flexi10: false,
					spotCombinedOptions: [ 5, 6, 7, 8],
					spotInsert: true
				},
				priority: 501
			},
			{
				name: "Mini Multi",
				param: {
					minstake: 300,
					horses: 4,
					multiOptions: [
						4,
						5,
						6
					],
					complimentary: false,
					hasboxed: false,
					hasx: true,
					hasall: true,
					hasrepl: true,
					hasspot: true,
					flexi50: true,
					flexi25: true,
					flexi10: false,
					spotCombinedOptions: [ 5, 6, 7, 8]
				},
				priority: 701
			},
			// This is Pick5
			{
				name: "NP5",
				param: {
					minstake: 100,
					horses: 5,
					complimentary: true,
					hasboxed: false,
					hasx: true,
					hasall: true,
					hasrepl: true,
					hasspot: true,
					flexi50: true,
					flexi25: true,
					flexi10: true,
					spotCombinedOptions: [ 6, 7, 8],
					spotInsert: false
				},
				priority: 602
			},
			{
				name: "Pick5",
				param: {
					minstake: 100,
					horses: 5,
					complimentary: true,
					hasboxed: false,
					hasx: true,
					hasall: true,
					hasrepl: true,
					hasspot: true,
					flexi50: true,
					flexi25: true,
					flexi10: true,
					spotCombinedOptions: [ 6, 7, 8],
					spotInsert: false
				},
				priority: 602
			},
		]


	},
	mutations: {


		changeTimelineDate(state, date) {
			state.selected = moment(date).format('YYYY-MM-DD');
			this.dispatch('getRacesData', state.selected);
		},
		changeTimelineRace(state, race) {
			state.timeline.raceData = race;
		},

		setTodayData(state, data) {
			state.timeline.today = data;
		},
		setSpecifiedData(state, data) {
			state.timeline.specified = data;
		},

		setRaceParams(state, params) {
			state.meetingId = params.meetingId;
			state.raceId = params.raceId;
			this.dispatch('getMeeting');
			this.dispatch('getRace');
		},
		setRaceId(state, id){
			state.raceId = id;
			this.dispatch('getRaceById');
		},
		setMeetingId(state, id){
			state.meetingId = id;
			this.dispatch('getMeeting');
		},
		setCurrentRace(state, obj) {

			if(obj.refresh && obj.type === 'race'){

				//Refresh action - smart update of race data
				state.current['race'].status = obj.data.status;
				state.current['race'].time = obj.data.time;

				obj.data.runners.forEach((refreshRunner)=>{
					let index = state.current['race'].runners.findIndex((runner)=> runner.id === refreshRunner.id);
					if(index > -1){
						state.current['race'].runners[index] = Object.assign({}, state.current['race'].runners[index], refreshRunner );
					}
				});

			}else{

				// Main road
				state.current[obj.type] = obj.data;
			}


			if (state.current.race && obj.data && obj.type === 'race') {
				this.commit('changeTimelineDate', state.current.race.time);
			}

		}
	},

	getters: {
		selectedMeetingDate(state) {
			return state.selected;
		},

		//Leave it for timeline
		currentRaceData(state) {
			//Meetings data orchestrator
			let today = moment(new Date()).format('YYYY-MM-DD');


			if (state.selected === today) {
				//Return today data
				return state.timeline.today !== null ? state.timeline.today.events.sort(compareByR) : null;
			} else {

				if (state.timeline.specified && state.timeline.specified.date === state.selected) {
					//Return specified date
					return state.timeline.specified.events.sort(compareByR);
				}
			}

			//Return null if nothing was found
			return null;
		},

		//For race page
		currentRace(state, getters) {

			//Boilerplate for race object
			let race = {
				meeting: {
					//Template to reduce errors
					races: []
				},
				details: {
					status: 'NONE'
				}
			};

			//Only valid data to output
			if (state.current.meeting !== null && typeof state.meetingId !== 'undefined' && state.current.meeting.id.toString() === state.meetingId.toString()) {
				race.meeting = state.current.meeting;


				//
				if (getters.currentRaceData) {

					let tmr = getters.currentRaceData.find(el => el.id === race.meeting.id);
					race.meeting.allRaces = tmr ? tmr.races : [];
				}
			}


			if (state.current.race !== null && state.current.race.id.toString() === state.raceId.toString()) {
				race.details = state.current.race;
			}
			return race;
		},

		todayRaceData(state) {
			return state.timeline.today !== null ? state.timeline.today.events : null;
		},
		closestRace(state) {
			const r = {
				found: false,
				meetingId: null,
				raceId: null,
				time: moment().add(1, 'day').valueOf() // Set maximum tomorrow, by default
			};

			if (state.timeline.today && state.timeline.today.events) {
				state.timeline.today.events.forEach(meeting => {

					for (let race of meeting.races) {

						let time = moment(race.time).valueOf();
						if (race.status === 'OPEN' && time < r.time) {
							r.found = true;
							r.meetingId = meeting.id;
							r.raceId = race.id;
							r.time = time
						}
					}
				})
			}


			return r;
		},

		getTypePriorityByName: state => name =>{

			name = snakeCase(name);

			let result = state.rules.find((el)=> snakeCase(el.name) === name);

			if(result){
				return result.priority
			}else{
				return 999;
			}

		}
	},
	actions: {

		getRacesData({commit}, date) {

			//Download general race info

			let today = moment(new Date()).format('YYYY-MM-DD');
			let isToday = false;


			//If date specified, then format it
			if (typeof date !== 'undefined') {

				date = moment(date).format('YYYY-MM-DD');

			}

			if (typeof date === 'undefined' || (typeof date !== 'undefined' && date === today)) {
				isToday = true;
				date = today;

			}

			instance.get(raceApi.timeline + date+ '?timestamp='+new Date().valueOf())
				.then((responce) => {
					if (responce.data.status && responce.data.status === 'SUCCESS') {

						responce.data.content.events = filterDisabled(responce.data.content.events);

						if (isToday) {
							commit('setTodayData', responce.data.content);

						} else {
							commit('setSpecifiedData', responce.data.content);
						}

					} else {
						console.warn('getRacesData request error');
						//console.warn(responce);
					}

				})
				.catch((er) => {
					console.warn(er);
				});

		},


		/**
		 * Get Meeting and simple race data according  state.meetingId && state.raceId
		 * @param state
		 * @param commit
		 */
		getMeeting({state, commit}) {

			if (state.meetingId !== null && state.raceId !== null) {

				//Get Race general info
				instance.get(raceApi.meeting + state.meetingId + '/races/' + state.raceId+ '?timestamp='+new Date().valueOf())
					.then((responce) => {


						if (responce.data.status && responce.data.status === 'SUCCESS' && responce.data.content.events.length > 0) {

							let temp = responce.data.content.events.find((el)=> el.id.toString() === state.meetingId.toString() );
							commit('setCurrentRace', {
								type: 'meeting',
								data: temp
							});

						} else {
							console.warn('getCurrentRace->base request error');
							//console.warn(responce);
						}

					})
					.catch((er) => {
						console.warn(er);
					});
			}

		},
		/**
		 * Get Race details according state.raceId
		 * @param state
		 * @param commit
		 */
		getRace({state, commit}) {

			if (state.raceId !== null) {
				//Get Race details
				instance.get(raceApi.race + state.raceId + '?timestamp='+new Date().valueOf(), {
					headers: {
						'Cache-Control': 'no-cache'
					}
				})
					.then((responce) => {


						if (responce.data.status && responce.data.status === 'SUCCESS') {

							commit('setCurrentRace', {
								type: 'race',
								data: responce.data.content
							});

						} else {
							console.warn('getCurrentRace->details request error');
							//console.warn(responce);
						}

					})
					.catch((er) => {
						console.warn(er);
					});
			}


		},
		/**
		 * Get Race details according state.raceId
		 * @param state
		 * @param commit
		 */
		getRaceById({state, commit}) {

			if (state.raceId !== null) {
				//Get Race details
				instance.get(raceApi.race + state.raceId + '?timestamp='+new Date().valueOf(), {
					headers: {
						'Cache-Control': 'no-cache'
					}
				})
					.then((responce) => {


						if (responce.data.status && responce.data.status === 'SUCCESS') {

							commit('setCurrentRace', {
								type: 'race',
								data: responce.data.content
							});

							commit('setMeetingId', responce.data.content.meeting_id);

						} else {
							console.warn('getCurrentRace->details request error');
							//console.warn(responce);
						}

					})
					.catch((er) => {
						console.warn(er);
					});
			}


		},
		/**
		 * Get Race details according state.raceId
		 * @param state
		 * @param commit
		 */
		getRaceRefresh({state, commit}) {

			if (state.raceId !== null) {
				//Get Race details
				instance.get(raceApi.race + state.raceId + '/refresh' + '?timestamp='+new Date().valueOf(), {
					headers: {
						'Cache-Control': 'no-cache'
					}
				})
					.then((responce) => {


						if (responce.data) {

							commit('setCurrentRace', {
								type: 'race',
								data: responce.data.content,
								refresh: true
							});

						} else {
							console.warn('getCurrentRace->details request error');
							//console.warn(responce);
						}

					})
					.catch((er) => {
						console.warn(er);
					});
			}


		},


	}
}
